import React, { Dispatch, createContext, useReducer } from 'react'
import { SortedServer } from './index'

export interface IState {
  download: number
  upload: number
  ping: number
  sortedServer?: SortedServer
  clientIP: string
  isSpeedCheckRunning: boolean
  isOptimalLocationLoaded: boolean
}

interface IDownload {
  type: 'SPEED_CHECK_DOWNLOAD'
  payload: IState
}

interface IUpload {
  type: 'SPEED_CHECK_UPLOAD'
  payload: IState
}

interface IPing {
  type: 'SPEED_CHECK_PING'
  payload: IState
}

interface ISortedServer {
  type: 'SORTED_SERVER'
  payload: IState
}
interface IClientIP {
  type: 'CLIENT_IP_ADDRESS'
  payload: IState
}
interface IResetState {
  type: 'RESET'
  payload: IState
}
interface ISpeedCheckState {
  type: 'SPEED_CHECK_RUNNING_STATE'
  payload: IState
}

export type Actions =
  | IDownload
  | IUpload
  | IPing
  | ISortedServer
  | IClientIP
  | IResetState
  | ISpeedCheckState

export const reducer = (state: IState, action: Actions) => {
  switch (action.type) {
    case 'SPEED_CHECK_DOWNLOAD':
      return {
        ...state,
        download: action.payload.download,
      }
    case 'SPEED_CHECK_UPLOAD':
      return {
        ...state,
        upload: action.payload.upload,
      }
    case 'SPEED_CHECK_PING':
      return {
        ...state,
        ping: action.payload.ping,
      }
    case 'SORTED_SERVER':
      return {
        ...state,
        sortedServer: action.payload.sortedServer,
        isOptimalLocationLoaded: action.payload.isOptimalLocationLoaded,
      }
    case 'CLIENT_IP_ADDRESS':
      return {
        ...state,
        clientIP: action.payload.clientIP,
      }
    case 'RESET':
      return action.payload
    case 'SPEED_CHECK_RUNNING_STATE':
      return {
        ...state,
        isSpeedCheckRunning: action.payload.isSpeedCheckRunning,
      }
    default:
      return { ...state }
  }
}

interface IContextProps {
  state: IState
  dispatch: Dispatch<Actions>
}

export const SpeedCheckContext = createContext({} as IContextProps)

const initialState: IState = {
  download: 0,
  upload: 0,
  ping: 0,
  sortedServer: undefined,
  clientIP: '',
  isSpeedCheckRunning: false,
  isOptimalLocationLoaded: false,
}

export function SpeedCheckProvider(props: any) {
  const [state, dispatch] = useReducer(reducer, initialState)

  const value = { state, dispatch }
  return (
    <SpeedCheckContext.Provider value={value}>
      {props.children}
    </SpeedCheckContext.Provider>
  )
}
